import i18n from "i18next";
import k from "src/i18n/keys";
import { useMemo, type ReactElement } from "react";
import { useSelector } from "react-redux";
import { Button } from "@unifize/sarah";

import useSelectedAiSuggestions from "src/hooks/ai/useSelectedAiSuggestions";
import ButtonLoader from "src/components/Dock/Checklist/Conversation/Loader";
import { getChecklistFieldSettings, getMessageData } from "src/reducers";
import { AiSuggestionState } from "src/constants/ai";
import { ButtonGroup } from "./styles";

import type { FieldId } from "src/types";
import type { AiNotificationData, Message } from "src/ts-types";

type Props = {
  isLoading: boolean;
  handleChecklistFill: () => void;
  selectedFields: Set<FieldId>;
};

// Replace below styles with disabled state once Sarah
// button component supports it.
const buttonStyle = {
  width: "100%",
  borderRadius: "4px",
};

const disabledButtonStyle = {
  ...buttonStyle,
  opacity: 0.5,
  cursor: "not-allowed",
};

const AddToChecklist = ({
  isLoading,
  handleChecklistFill,
  selectedFields,
}: Props): ReactElement | null => {
  return (
    <ButtonGroup>
      {isLoading ? (
        <ButtonLoader />
      ) : (
        <Button
          onClick={handleChecklistFill}
          variant="primary"
          style={selectedFields.size === 0 ? disabledButtonStyle : buttonStyle}
        >
          {i18n.t(k.ADD_TO_CHECKLIST)}
        </Button>
      )}
    </ButtonGroup>
  );
};

export default AddToChecklist;
